// Deploy trigger: 2026-09-12
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "assets/css/demo.css";
import "assets/css/custom.css";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import PrivateRoute from "./components/PrivateRoute";
import { ErrorProvider } from "./contexts/ErrorContext";
import { initTelemetry } from "./services/telemetry";

// Auth views
import Login from "views/Pages/Auth/Login.js";
import ForgotPassword from "views/Pages/Auth/ForgotPassword.js";
import ResetPassword from "views/Pages/Auth/ResetPassword.js";
import RegisterPage from "views/Pages/RegisterPage.js";
import VerifyEmailPage from "views/Pages/Auth/VerifyEmailPage.js";

// Admin views — imported directly here so nested routes are self-contained in this file
import Dashboard from "views/Pages/Dashboard/Dashboard.js";
import Users from "views/Pages/Users/Users.js";
import CustomFields from "views/Pages/CustomFields/CustomFields.js";
import ContactLists from "views/Pages/Contacts/ContactLists.js";
import Campaigns from "views/Pages/Campaign/Campaigns.js";
import CreateCampaign from "views/Pages/Campaign/CreateCampaign.js";
import CampaignProgress from "views/Pages/Campaign/CampaignProgress.js";
import P2PSender from "views/Pages/Campaign/P2PSender.js";
import ActivePhoneNumbers from "views/Pages/PhoneNumbers/ActiveNumbers";
import PhoneNumbers from "views/Pages/PhoneNumbers/PhoneNumbers.js";
import Billing from "views/Pages/Billing/Billing.js";
import PaymentMethod from "views/Pages/Billing/PaymentMethod.js";
import Settings from "views/Pages/Profile/Settings.js";
import Conversations from "views/Pages/Conversation/ConversationAccess";
import ContactUs from "views/Pages/Support/ContactUs.js";
import PrivacyTerms from "views/Pages/Legal/PrivacyTerms.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Initialize global bug tracking telemetry
initTelemetry();

root.render(
  <BrowserRouter>
    <ErrorProvider>
      <Routes>

        {/* ── Auth routes (public) ────────────────────────────────────── */}
      <Route path="/auth" element={<AuthLayout />}>
        {/* Default /auth → /auth/login */}
        <Route index element={<Navigate to="login" replace />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Navigate to="/auth/login" replace />} />
        <Route path="verify-email" element={<Navigate to="/auth/login" replace />} />
        <Route path="ForgotPassword" element={<ForgotPassword />} />
        <Route path="ResetPassword" element={<ResetPassword />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="privacy" element={<PrivacyTerms defaultTab="privacy" />} />
        <Route path="terms" element={<PrivacyTerms defaultTab="terms" />} />
      </Route>

      {/* Public Standalone Routes */}
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/privacy" element={<PrivacyTerms defaultTab="privacy" />} />
      <Route path="/terms" element={<PrivacyTerms defaultTab="terms" />} />
      <Route path="/legal" element={<PrivacyTerms defaultTab="privacy" />} />

      {/* ── Admin routes (protected) ────────────────────────────────── */}
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      >
        {/* Default /admin → /admin/dashboard */}
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="custom-fields" element={<CustomFields />} />
        <Route path="contact-lists" element={<ContactLists />} />
        <Route path="campaign-overview" element={<Campaigns />} />
        <Route path="create-campaign" element={<CreateCampaign />} />
        <Route path="campaign-progress" element={<CampaignProgress />} />
        <Route path="campaigns/:id/p2p" element={<P2PSender />} />
        <Route path="phone-numbers" element={<ActivePhoneNumbers />} />
        <Route path="buy-phone-numbers" element={<PhoneNumbers />} />
        <Route path="billing" element={<Billing />} />
        <Route path="payment-Method" element={<PaymentMethod />} />
        <Route path="settings" element={<Settings />} />
        <Route path="conversations" element={<Conversations />} />
        <Route path="contact-us" element={<ContactUs />} />
      </Route>

        {/* Default: redirect / to dashboard (PrivateRoute will redirect to login if no token) */}
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />

      </Routes>
    </ErrorProvider>
  </BrowserRouter>
);
